import React from 'react';

function ColorPalette({
  colorData,
  handleColorPaletteClose,
  pickScheduleColor,
}) {
  return (
    <div
      className="lab-rslt-actn-popup"
      style={{
        position: 'absolute',
        width: '300px',
        backgroundColor: '#ffffff',
        zIndex: 1,
      }}
    >
      <div
        style={{
          minHeight: '26px',
          width: '100%',
          height: '28px',
          borderBottom: '1px solid #D1E3C5 !important',
          border: 'none',
          display: 'flex',
          boxShadow: '0 0 30px rgb(0 0 0 / 30%)',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            margin: '7px 0px 0px 15px',
            color: '#1ab3a2',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          Pick Color for schedule appointment
        </span>
        <span
          style={{
            fontSize: '16px',
            cursor: 'pointer',
            margin: '7px 15px 0px 0px',
            color: '#1ab3a2',
            fontWeight: 'bold',
          }}
          onClick={handleColorPaletteClose}
        >
          X
        </span>
      </div>
      <div className="" style={{ display: 'flex', flexWrap: 'wrap' }}>
        {colorData &&
          colorData.map((item, idx) => {
            return (
              <div
                key={idx}
                className="pick-color"
                style={{
                  background: item,
                  borderBottom: '1px solid #ffffff',
                  borderRight: '1px solid #ffffff',
                  cursor: 'pointer',
                  height: '30px',
                  width: '30px',
                }}
                title=""
                onClick={() => pickScheduleColor(item)}
              ></div>
            );
          })}

        <div
          style={{
            height: '24px',
            cursor: 'pointer',
            marginLeft: '136px',
            marginTop: '8px',
            fontWeight: 'bold',
          }}
          title="No Color"
          onClick={() => pickScheduleColor('')}
        >
          No Color
        </div>
      </div>
    </div>
  );
}

export default ColorPalette;
